import * as React from 'react';
import { mergeRefs } from '@react-aria/utils';
import { SelectionListItemContext } from '../../context/SelectionListItemContext.js';
import { useSelectionListItem } from '../../hooks/useSelectionListItem.js';
import { MultipleSelectionListItem } from './components/MultipleSelectionListItem.js';
import { SingleSelectionListItem } from './components/SingleSelectionListItem.js';

var InternalSelectionListItem = /*#__PURE__*/React.memo(/*#__PURE__*/React.forwardRef(function (props, ref) {
  var internalRef = React.useRef(null);
  var _useSelectionListItem = useSelectionListItem(props, internalRef),
    rendered = _useSelectionListItem.rendered,
    listItemProps = _useSelectionListItem.listItemProps,
    isSelected = _useSelectionListItem.isSelected,
    isDisabled = _useSelectionListItem.isDisabled,
    selectionMode = _useSelectionListItem.selectionMode;
  var ListItem = selectionMode === 'multiple' ? MultipleSelectionListItem : SingleSelectionListItem;
  return /*#__PURE__*/React.createElement(SelectionListItemContext.Provider, {
    value: {
      isSelected: isSelected,
      isDisabled: isDisabled
    }
  }, /*#__PURE__*/React.createElement(ListItem, {
    ref: mergeRefs(internalRef, ref),
    listItemProps: listItemProps,
    isSelected: isSelected,
    isDisabled: isDisabled
  }, rendered));
}));

export { InternalSelectionListItem };
//# sourceMappingURL=InternalSelectionListItem.js.map
